import { apiRTK } from 'api/api-rtk'

import type { LogEntry } from './types'

export const api = apiRTK.injectEndpoints({
	endpoints: create => {
		const createEndpoint = (url: string) =>
			create.mutation<any, LogEntry>({
				query: data => ({
					data,
					method: 'POST',
					url
				})
			})

		return {
			logError: createEndpoint('logs/error'),
			logInfo: createEndpoint('logs/information'),
			/** @deprecated */
			logs: createEndpoint('logs'),
			logTrace: createEndpoint('logs/trace'),
			logWarn: createEndpoint('logs/warning')
		}
	},
	overrideExisting: true
})
